/**
 * KeenSliderModule
 */
import KeenSlider from './keen-slider-master/keen-slider.esm';

export module KeenSliderModule {
  export class Service {
    static readonly sliderTime = 4000;
    static settimeoutId: number;
    static slider: any;
    static sliderElement: HTMLElement | null;

    constructor(language?: string) {
      Service.sliderElement = document.getElementById('keen-slider');
      if (Service.sliderElement) {
        Service.sliderAction();
      }
    }

    /**
     * Slider処理
     */
    public static sliderAction() {
      if (Service.sliderElement) {
        Service.slider = new KeenSlider(Service.sliderElement, {
          loop: true,
          duration: 1000,
          dragStart: () => {
            Service.autoplay(false);
          },
          dragEnd: () => {
            Service.autoplay(true);
          },
        });

        Service.sliderElement.addEventListener("mouseover", () => {
          Service.autoplay(false);
        });

        Service.sliderElement.addEventListener("mouseout", () => {
          Service.autoplay(true);
        });

        Service.autoplay(true);
      }
    }

    /**
     * オートプレイ
     * @param $run boolean.
     */
    public static autoplay($run: boolean) {
      if (Service.settimeoutId) {
        clearTimeout(Service.settimeoutId);
      }
      Service.settimeoutId = window.setTimeout(function () {
        if ($run && Service.slider) {
          Service.slider.next();
        }
        Service.autoplay($run);
      }, Service.sliderTime);
    }
  }
}
